// extracted by mini-css-extract-plugin
export var aggregationCell = "_2w-p";
export var aggregationRow = "_2w-o";
export var borderlessSpinnerContainer = "_2w-3";
export var cardLayout = "_2w-6";
export var cardLayoutNoFooter = "_2w-a";
export var cardLayoutPageControl = "_2w-9";
export var cardLayoutWithFooter = "_2w-8";
export var closeIcon = "_2w-h";
export var columnHeaderSurface = "_2w-d";
export var columnHeaderSurfaceDragOverlay = "_2w-x";
export var columnHeaderSurfaceResizing = "_2w-u";
export var contextMenuAnchor = "_2w-1";
export var draggableColumnHeader = "_2w-v";
export var draggableColumnHeaderOverlay = "_2w-w";
export var expandIcon = "_2w-i";
export var expanded = "_2w-j";
export var filterDropdown = "_2w-k";
export var filterDropdownDivider = "_2w-f";
export var filterDropdownHeader = "_2w-n";
export var filterDropdownItem = "_2w-m";
export var filterDropdownModal = "_2w-l _2w-k";
export var filterItem = "_2w-e";
export var normalCellWithAdjustableBorder = "_2w-g";
export var pinButtonContainer = "_2w-q";
export var pinIcon = "_2w-r";
export var pinIconActive = "_2w-s";
export var spinner = "_2w-0";
export var spinnerContainer = "_2w-2";
export var tableContainer = "_2w-4";
export var tableContentDraggingColumns = "_2w-c";
export var tableContentInner = "_2w-7";
export var tableContentInnerFill = "_2w-b";
export var tableContentWrapper = "_2w-5";
export var viewButtonContainer = "_2w-t";